import {
  DebitLimitTypes,
  EnumInvoiceClosureMethod,
  EnumVATStatus,
} from "@/enums/accounting-enums";
import {
  CustomerMainRequiredKey,
  type CustomerRequiredFieldRules,
} from "@/utils/customer-required-fields";
import { getPaymentTermDisplayName } from "@/utils/get-payment-term-display-name";
import type { PaymentTermItem } from "@/services/api-service/customers/payment-terms-api";

const accountingInputs = (
  state,
  _isSupplier,
  t,
  rules: CustomerRequiredFieldRules,
  paymentTerms: PaymentTermItem[] = [],
) => {
  const paymentTermsList = (paymentTerms ?? [])
    .slice()
    .sort((a, b) => a.code - b.code)
    .map((term) => ({
      value: term.code,
      text: getPaymentTermDisplayName(term.name, t),
    }));

  const vatStatusList: { value: number; text: string }[] = Object.values(
    EnumVATStatus,
  )
    .filter((value) => typeof value === "number")
    .map((value) => ({
      value: value as number,
      text: t(`accounting.${EnumVATStatus[value]}`),
    }));

  const debitLimitTypesList: { value: number; text: string }[] = Object.values(
    DebitLimitTypes,
  )
    .filter((value) => typeof value === "number")
    .map((value) => ({
      value: value as number,
      text: t(`accounting.${DebitLimitTypes[value]}`),
    }));

  const invoiceClosureMethodList: { value: boolean; text: string }[] = [
    {
      value: false,
      text: t(
        `accounting.${
          EnumInvoiceClosureMethod[EnumInvoiceClosureMethod.accounting]
        }`,
      ),
    },
    {
      value: true,
      text: t(
        `accounting.${
          EnumInvoiceClosureMethod[
            EnumInvoiceClosureMethod.internalAndAccounting
          ]
        }`,
      ),
    },
  ];

  return [
    {
      name: "PaymentTerms",
      label: "accounting.paymentTerms",
      type: "select",
      placeholder: "accounting.paymentTerms",
      required: rules.main.has(CustomerMainRequiredKey.PAYMENT_TERMS),
      parameterKey: "termOfPayment",
      options: paymentTermsList,
      value: state?.termOfPayment,
      isValid: true,
    },
    {
      name: "CentralCard",
      label: "accounting.centralCard",
      type: "text",
      placeholder: "accounting.centralCard",
      required: false,
      parameterKey: "fatherCard",
      options: [],
      value: state?.fatherCard,
      isValid: true,
    },
    {
      name: "vatStatus",
      label: "accounting.defaultVat",
      type: "select",
      placeholder: "accounting.defaultVat",
      required: false,
      parameterKey: "vatStatus",
      options: vatStatusList,
      value: state?.vatStatus,
      isValid: true,
    },
    {
      name: "deductedAtSource",
      label: "accounting.deductedAtSource",
      type: "switch",
      required: false,
      parameterKey: "deductedAtSource",
      options: [],
      value: state?.deductedAtSource,
      isValid: true,
    },
    {
      name: "invoiceClosureMethod",
      label: "accounting.invoiceClosureMethod",
      type: "select",
      placeholder: "accounting.invoiceClosureMethod",
      required: false,
      parameterKey: "isOptionalClosingOrder",
      options: invoiceClosureMethodList,
      value: state?.isOptionalClosingOrder,
      isValid: true,
    },
    {
      name: "debitLine",
      label: "accounting.debitLine",
      type: "text",
      placeholder: "accounting.debitLine",
      required: false,
      parameterKey: "debitLine",
      options: [],
      value: state?.debitLine,
      isValid: true,
    },
    {
      name: "debitLimitType",
      label: "accounting.debitLimitType",
      type: "select",
      placeholder: "accounting.debitLimitType",
      required: false,
      parameterKey: "debitLimitType",
      options: debitLimitTypesList,
      value: state?.debitLimitType,
      isValid: true,
    },
  ];
};

export { accountingInputs };
